<template>
<div id="top3">
    <div class="cc-header">
        <!--<dv-decoration-7 :color="['#f00', '#f00']" style="width: 5rem;height: 0.5rem;"><div style="margin: 0 0.1rem;"> 设备地域分布 </div></dv-decoration-7>-->
        设备地域分布
    </div>
    <div class="d-flex jc-center">
        <div id="mapChart" class="mapChart"></div>
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
var region = storage.getItem("region");
const echarts = require("echarts");
export default {
    data() {
        return {};
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            var mapChart = echarts.init(document.getElementById("mapChart"));
            this.$http.get("/dataView/temp/getTempMapDistribution?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var result = res.data.result;
                    var mapJosn = "china";
                    if(region != 'false' && this.Map.mapMap.get(region) != undefined){
						mapJosn = this.Map.mapMap.get(region);
					}
                    var option = {
                        geo: {
                            map: mapJosn,
                            label: {
                                show: true,
								textStyle: {
									color: '#0692a4',
									fontSize: fontSize(0.13)
								},
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        color: '#fff'
                                    }
                                }
                            },
                            roam: true,
                            zoom: 1.2,
                            itemStyle: {
                                normal: {
                                    areaColor: "#142957",
                                    borderColor: "#0692a4"
                                },
                                emphasis: {
                                    areaColor: "#0b1c2d"
                                }
                            }
                        },
                        series: [{
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            zlevel: 1,
                            // symbolSize: function (val) {
                            //     return val[2] / 1;
                            // },
                            showEffectOn: 'render',
                            rippleEffect: {
                                brushType: 'stroke'
                            },
                            hoverAnimation: true,
                            label: {
                                normal: {
                                    formatter: '{b} : {@2}',
                                    position: 'top',
                                    show: true
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#f4e925',
                                    shadowBlur: 11,
                                    shadowColor: '#333'
                                }
                            },
                            data: result
                        }]
                    };
                    mapChart.setOption(option);
                    window.addEventListener("resize", () => mapChart.resize(), false);
                }
            });
        }
    }
};
function fontSize(res){
    let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
    if (!clientWidth) return;
    let fontSize = 100 * (clientWidth / 1920);
    return res*fontSize;
}
</script>

<style lang="scss">
#top3 {
    height: 6.8rem;

    .cc-header {
        height: 0.75rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .mapChart {
        width: 8rem;
        height: 5.8rem;
    }
}
</style>
